export const documentsContent = [
  {
    text: "Regulamento - Campanha de Aniversário 2026",
    link: "https://workdrive.zohoexternal.com/external/9a08e66b0e5cb8ccb651f71c29f82488f4e33012d948bd50ba8b890a878b8558/download",
    apiInfo: "regulamento_campanha_aniversario_2026_doc",
    active: true,
  },
  {
    text: "Monitoramento Prudencial",
    link: "https://image.marketing.aurenenergia.com.br/lib/fe3915707564047f7d1778/m/1/a9f5cd91-d939-49b4-a79a-e6dc8688e3d3.pdf",
    apiInfo: "monitoramento_prudencial_doc",
    active: true,
  },
  {
    text: "Preços de Referência Comparáveis",
    link: "https://image.marketing.aurenenergia.com.br/lib/fe3915707564047f7d1778/m/1/7afa0cda-52a9-4bee-943f-ba0324956072.pdf",
    apiInfo: "preços_de_referência_comparáveis_doc",
    active: true,
  },
];
